import {BaseEntity} from "./BaseEntity";

export class AlertingAction implements BaseEntity {
    constructor(
        public id?:number,
        public name?:string,
        public adminPopupAlert?:boolean,
        public checkin?:boolean,
        public checkout?:boolean,
        public logAlarm?:boolean,
        public onlyIfCheckedIn?:boolean,
        public autoAck?:boolean,
        public pluginActions?:string,
        public changeLocation?:boolean,
        public smtpEmail?:boolean,
        public gpO1?:boolean,
        public gpO1State?:string,
        public gpO1Seconds?:number,
        public gpO2?:boolean,
        public gpO2State?:string,
        public gpO2Seconds?:number,
        public lastModifiedBy?:string) {
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.adminPopupAlert = json.adminPopupAlert;
        this.checkin = json.checkin;
        this.checkout = json.checkout;
        this.logAlarm = json.logAlarm;
        this.onlyIfCheckedIn = json.onlyIfCheckedIn;
        this.autoAck = json.autoAck;
        this.pluginActions = json.pluginActions;
        this.changeLocation = json.changeLocation;
        this.smtpEmail = json.smtpEmail;
        this.gpO1 = json.gpO1;
        this.gpO1State = json.gpO1State;
        this.gpO1Seconds = json.gpO1Seconds;
        this.gpO2 = json.gpO2;
        this.gpO2State = json.gpO2State;
        this.gpO2Seconds = json.gpO2Seconds;
        this.lastModifiedBy = json.lastModifiedBy;
    }

}
